import { KeycloakProfile } from 'keycloak-js';
import { BooleanCons, StringConst } from 'src/app/constants/const';

export interface ExtendedKeycloakProfile extends KeycloakProfile {
  attributes?: {[key: string]: string};
}
export interface ILoginReq {
  email: string;
  password: string;
}

export interface ILoginRes {
  token: string;
}

export interface IUserInfoRes {
  cardcode: string;
  email: string;
  email_verified: boolean;
  family_name: string;
  given_name: string;
  locale: string;
  name: string;
  preferred_username: string;
  sub: string;
  advisorId: string;
}

export class UserInfo {
  cardcode: string;
  email: string;
  emailVerified: boolean;
  familyName: string;
  givenName: string;
  locale: string;
  name: string;
  preferredUsername: string;
  sub: string;
  advisorId: string;

  constructor() {
    this.cardcode = StringConst.empty;
    this.email = StringConst.empty;
    this.emailVerified = BooleanCons.false;
    this.familyName = StringConst.empty;
    this.givenName = StringConst.empty;
    this.locale = StringConst.empty;
    this.name = StringConst.empty;
    this.preferredUsername = StringConst.empty;
    this.sub = StringConst.empty;
    this.advisorId = StringConst.empty;
  }
}

export interface IUpdatePassword {
  email: string;
  password: string;
  newPassword: string;
}
